import { Outlet } from 'react-router-dom';
import { useAuth } from './useAuth';

export function RequireAdmin() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="text-center">
          <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
          <p className="font-body text-text-secondary">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user?.isAdmin) {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="text-center">
          <h1 className="mb-2 font-heading text-4xl font-bold text-error">
            403
          </h1>
          <h2 className="mb-4 font-heading text-xl font-semibold text-text-primary">
            Access Forbidden
          </h2>
          <p className="font-body text-text-secondary">
            You do not have permission to access the admin area.
          </p>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
